"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tiny_slider_1 = require("tiny-slider/src/tiny-slider");
var lazyLoader_1 = __importDefault(require("../modules/lazyLoader"));
var config_1 = __importDefault(require("../config"));
var Slider = /** @class */ (function () {
    function Slider() {
        var _this = this;
        this.load = function (config) {
            _this.create(config);
        };
        this.transitionStart = function () {
            lazyLoader_1.default.update();
        };
        this.create = function (config) {
            _this.slider = (0, tiny_slider_1.tns)(__assign(__assign({}, _this.defaultConfig), config));
            _this.slider.events.on('transitionStart', _this.transitionStart);
        };
        this.slider = null;
        this.defaultConfig = {
            items: 1.5,
            slideBy: 1,
            gutter: 5,
            speed: config_1.default.duration,
            controls: false,
            mouseDrag: false,
            touch: true,
            swipeAngle: 90,
            nav: false,
            responsive: {
                1024: {
                    items: 3,
                    gutter: 10,
                    controls: true
                }
            }
        };
    }
    Slider.prototype.init = function (node, config) {
        if (!node || !node.children.length)
            return;
        this.defaultConfig.nextButton = node.querySelector('[data-slider-next-btn]');
        this.defaultConfig.container = node;
        this.load(config);
        return this.slider;
    };
    return Slider;
}());
exports.default = new Slider();
